<template>
  <div class="ad-container">
    <div :id="adSlotId" class="ad-top-banner"></div>
  </div>
</template>

<script>
export default {
  name: 'AD_TopBanner',
  props: {
    adUnitPath: {
      type: String,
      default: '/23295702748/ABCD1234',
    },
    adSlotId: {
      type: String,
      default: 'div-gpt-ad-1747035285731-0',
    },
  },
  data() {
    return {
      slot: null,
    }
  },
  methods: {
    waitForGPT() {
      return new Promise((resolve) => {
        if (window.googletag?.apiReady) {
          resolve()
          return
        }

        const checkGPT = () => {
          if (window.googletag?.apiReady) {
            resolve()
          } else {
            setTimeout(checkGPT, 100)
          }
        }
        checkGPT()
      })
    },
    defineSlot() {
      return new Promise((resolve) => {
        window.googletag = window.googletag || { cmd: [] }
        window.googletag.cmd.push(() => {
          const existingSlots = window.googletag.pubads().getSlots()
          const existingSlot = existingSlots.find(
            (slot) => slot.getSlotElementId() === this.adSlotId
          )

          if (existingSlot) {
            this.slot = existingSlot
            resolve()
            return
          }

          this.slot = window.googletag
            .defineSlot(
              this.adUnitPath,
              [
                [320, 50],
                [728, 90],
                [970, 90],
              ],
              this.adSlotId
            )
            .addService(window.googletag.pubads())

          this.slot.defineSizeMapping(
            window.googletag
              .sizeMapping()
              .addSize([0, 0], [[320, 50]])
              .addSize([768, 0], [[728, 90]])
              .addSize([1024, 0], [[970, 90]])
              .build()
          )

          if (existingSlots.length === 0) {
            window.googletag.pubads().enableSingleRequest()
            window.googletag.pubads().collapseEmptyDivs()
            window.googletag.enableServices()
          }

          resolve()
        })
      })
    },
    async initializeAd() {
      try {
        await this.waitForGPT()
        await this.defineSlot()
        window.googletag.cmd.push(() => {
          window.googletag.display(this.adSlotId)
        })
      } catch (error) {
        console.error('Ad initialization failed:', error)
      }
    },
  },
  mounted() {
    this.initializeAd()
  },
}
</script>

<style lang="scss" scoped>
.ad-container {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.ad-top-banner {
  display: block;
  margin: 0 auto;
  min-height: 50px;
  width: 100%;
  max-width: 320px; // Mobile default

  :deep(iframe) {
    width: 100% !important;
    height: auto !important;
    max-width: 100% !important;
  }

  :deep(img) {
    width: 100% !important;
    height: auto !important;
    max-width: 100% !important;
  }
}

@media (min-width: 768px) {
  .ad-top-banner {
    min-height: 90px;
    max-width: 728px;
  }
}

@media (min-width: 1024px) {
  .ad-top-banner {
    min-height: 90px;
    max-width: 970px;
  }
}
</style>
